import Vue from 'vue'

export default Vue.extend({
  props: {
    to: {
      type: Object,
      required: false,
      default: function() {
        return {
          name: '',
          params: {},
        }
      },
    },
  },

  computed: {
    route(): { name: string; params: object } {
      return {
        name: this.to.name,
        params: this.to.params,
      }
    },
  },
})
